import { render } from "./LicenseCardSmall.vue?vue&type=template&id=4a8fddac"
import script from "./LicenseCardSmall.vue?vue&type=script&lang=js"
export * from "./LicenseCardSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__